import { RestError } from "api/restClient.types";
import ExpandableNotification from "./ExpandableNotification";
import SimpleNotification from "./SimpleNotification";

type RestErrorNotificationProps = {
    titleOverride?: string;
    error: RestError;
    alwaysExpanded?: boolean;
};

export default ({ titleOverride, error, alwaysExpanded }: RestErrorNotificationProps) => {
    const { status, statusText, data } = error.response ?? {};
    const { title, message } = data ?? error.response ?? error ?? {};
    const effectiveMessage = message ?? data;
    const effectiveTitle = titleOverride ? `${titleOverride}${title ? `: ${title}` : ""}` : title;

    if (effectiveTitle && effectiveMessage) {
        return (
            <ExpandableNotification
                title={effectiveTitle}
                details={effectiveMessage}
                alwaysExpanded={alwaysExpanded}
            />
        );
    }

    if (effectiveTitle) {
        return <SimpleNotification title={effectiveTitle} subtitle={`${error}`} />;
    }

    if (statusText) {
        return <SimpleNotification title={statusText} subtitle={`${status}`} />;
    }

    return <SimpleNotification title={`${error}`} />;
};
